export const SET_GENERAL_DATA = 'SET_GENERAL_DATA'
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE'
export const SECTION_NAMES = 'SECTION_NAMES'
export const COMMITMENT = 'COMMITMENT'
export const FEEDBACK_SECTION = 'FEEDBACK_SECTION'
export const SECTION_MENU = 'SECTION_MENU'
export const SECTION_MENU_Remove = 'SECTION_MENU_Remove'
export const LOGIN_DETAILS = 'LOGIN_DETAILS'
export const GET_VARIABLES = 'GET_VARIABLES'
export const SECTION_LIST_HEADING = 'SECTION_LIST_HEADING'
export const SECTION_HEADING = 'SECTION_HEADING'
